<template>
  <div class="duam-list-wrapper">

    <!-- ════════════ RESUMO ════════════ -->
    <div class="duam-resumo">
      <div class="resumo-card">
        <span class="resumo-label">Total de DUAMs</span>
        <span class="resumo-valor">{{ resumo.total }}</span>
      </div>
      <div class="resumo-card">
        <span class="resumo-label">Valor Total</span>
        <span class="resumo-valor resumo-destaque">
          {{ resumo.dut_valortotal | formatNumeroBr }}
        </span>
      </div>
    </div>

    <!-- ════════════ TABELA ════════════ -->
    <div class="duam-table">
      <!-- Header (desktop) -->
      <div class="duam-header">
        <div class="col-duam">N° DUAM</div>
        <div class="col-contribuinte">Contribuinte</div>
        <div class="col-valor">Valor Atualizado</div>
        <div class="col-tributo">Tributo</div>
        <div class="col-competencia">Competência</div>
        <div class="col-vencimento">Vencimento</div>
        <div class="col-situacao">Situação</div>
        <div class="col-acoes"></div>
      </div>
      <!-- Linhas paginadas -->
      <ContextMenuDuam :visible="contextMenu.visible" :x="contextMenu.x" :y="contextMenu.y" :item="contextMenu.item"
                       @close="closeContextMenu"
                       @pagamento="pagamento"
                       @baixa-manual="showModalbaixaManual"
                       @alterar-duam="showModalAlterarDuam"
                       @print-comprovante="printComprovante"
                       @detalhe="guiaDetalhe"
      />
      <div v-for="(g, index) in guias" :key="index" @contextmenu="openContextMenu($event, g)" class="duam-row">
        <!-- N° DUAM -->
        <div class="col-duam" data-label="N° DUAM">
          <span class="duam-codigo">{{ g.dam_codigo }}</span>
        </div>

        <!-- Contribuinte -->
        <div class="col-contribuinte">
          <div class="contribuinte-info">
            <span class="contribuinte-nome">{{ g.pes_nome }}</span>
            <span class="contribuinte-doc">
              <template v-if="g.pes_cpfcnpj.length < 12">
                {{g.eco_codigo}} | {{ g.pes_cpfcnpj | VMask('###.###.###-##') }}
              </template>
              <template v-else>
                {{g.eco_codigo}} | {{ g.pes_cpfcnpj | VMask('##.###.###/####-##') }}
              </template>
            </span>
          </div>
        </div>

        <!-- Valor -->
        <div class="col-valor" data-label="Valor">
          <div class="valor-info">
            <span class="valor-total">{{ g.dut_valortotal | formatNumeroBr }}</span>
            <div class="valor-detalhes">
              <span class="valor-detalhe-item">
                Original: <strong>{{ g.dut_valortributo | formatNumeroBr }}</strong>
              </span>
              <span class="valor-detalhe-item">
                Multa: <strong>{{ g.dut_multa | formatNumeroBr }}</strong>
              </span>
              <span class="valor-detalhe-item">
                Juros: <strong>{{ g.dut_juros | formatNumeroBr }}</strong>
              </span>
            </div>
            <span v-if="g.pagamento" class="valor-pago">
              Pago: {{ g.pagamento.bab_valor_pago | formatNumeroBr }}
            </span>
          </div>
        </div>

        <!-- Tributo -->
        <div class="col-tributo" data-label="Tributo">
          <span class="tributo-badge">{{ g.tip_nome }}</span>
        </div>

        <!-- Competência -->
        <div class="col-competencia" data-label="Competência">
          {{ g.dam_mes_ref }}/{{ g.dam_ano_ref }}
        </div>

        <!-- Vencimento -->
        <div class="col-vencimento" data-label="Vencimento">
          <div class="vencimento-info">
            <span class="vencimento-atual">{{ g.dam_data_venc_atu | formatDate }}</span>
            <span class="vencimento-original">
              {{ g.dam_data_venc_orig | formatDate }}
            </span>
          </div>
        </div>

        <!-- Situação -->
        <div class="col-situacao" data-label="Situação">
          <span
              class="status-badge"
              :class="{
              'status-aberta': g.tab_codigo === '963',
              'status-vencida': g.tab_codigo === '964',
              'status-paga': g.pagamento,
              'status-outra': g.tab_codigo !== '963' && g.tab_codigo !== '964' && !g.pagamento
            }"
          >
            {{ g.pagamento ? 'Pago' : g.tab_nome }}
          </span>
        </div>
        <!-- Ações -->
        <div class="col-acoes">
          <b-dropdown size="sm" dropleft variant="light" toggle-class="btn-acoes" no-caret>
            <template #button-content>
              <i class="bx bx-dots-vertical-rounded"></i>
            </template>
            <b-dropdown-item
                v-if="(g.tab_codigo === '963' || g.tab_codigo === '964') && !g.pagamento"
                @click="pagamento(g)"
            >
              <i class="bx bx-money text-success mr-2"></i> Realizar Pagamento
            </b-dropdown-item>
            <b-dropdown-item
                v-if="(g.tab_codigo === '963' || g.tab_codigo === '964') && !g.pagamento"
                @click="showModalbaixaManual(g)"
            >
              <i class="bx bx-downvote text-dark mr-2"></i> Baixa Manual
            </b-dropdown-item>
            <b-dropdown-item @click="showModalAlterarDuam(g)">
              <i class="bx bx-edit text-primary mr-2"></i> Alterar DUAM
            </b-dropdown-item>
            <b-dropdown-item
                v-if="g.pagamento"
                @click="printComprovante(g)"
            >
              <i class="bx bx-printer text-info mr-2"></i> Comprovante
            </b-dropdown-item>
            <b-dropdown-divider/>
            <b-dropdown-item @click="guiaDetalhe(g)">
              <i class="bx bx-show-alt text-secondary mr-2"></i> Detalhes
            </b-dropdown-item>
          </b-dropdown>
        </div>
      </div>

      <!-- Estado vazio -->
      <div v-if="!guias || guias.length === 0" class="duam-empty">
        <i class="bx bx-file-blank"></i>
        <p>Nenhuma DUAM encontrada</p>
      </div>
    </div>

    <!-- ════════════ PAGINAÇÃO ════════════ -->
    <div v-if="totalPaginas > 1" class="duam-pagination-wrapper mb-3">
      <span class="pagination-info">
        Exibindo {{ startItem }}–{{ endItem }} de {{ resumo.total }}
      </span>
      <paginate
          :value="paginaAtual"
          :page-count="totalPaginas"
          :click-handler="mudarPagina"
          :prev-text="'‹'"
          :next-text="'›'"
          :container-class="'duam-pagination'"
          :page-class="'page-item'"
          :page-link-class="'page-link'"
          :prev-class="'page-item'"
          :prev-link-class="'page-link'"
          :next-class="'page-item'"
          :next-link-class="'page-link'"
          :active-class="'active'"
          :disabled-class="'disabled'"
      />
    </div>

  </div>
</template>

<script>
import Paginate from 'vuejs-paginate'
import ContextMenuDuam from "@/router/views/admin/components/gestao/ContextMenuDuam.vue";

export default {
  name: 'DuamList',
  components: {
    ContextMenuDuam,
    Paginate
  },
  props: {
    resumo: {
      type: Object
    },
    guias: {
      type: Array,
    },
    paginaAtual: {
      type: Number,
      default: 1
    },
    totalPaginas: {
      type: Number,
      default: 0
    },
    porPagina: {
      type: Number,
      default: 10
    }
  },
  data() {
    return {
      contextMenu: {
        visible: false,
        x: 0,
        y: 0,
        item: null
      },
      colDuamWidth: 100,
      resizing: false,
      resizeStartX: 0,
      resizeStartWidth: 0
    }
  },
  mounted() {
    window.addEventListener("click", this.closeContextMenu);
    window.addEventListener("scroll", this.closeContextMenu);
  },
  computed: {
    startItem() {
      return (this.paginaAtual - 1) * this.porPagina + 1
    },
    endItem() {
      return Math.min(this.paginaAtual * this.porPagina, this.resumo.total)
    },
  },
  beforeDestroy() {
    document.removeEventListener('mousemove', this.duranteResize)
    document.removeEventListener('mouseup', this.finalizarResize)
    window.removeEventListener("click", this.closeContextMenu);
    window.removeEventListener("scroll", this.closeContextMenu);
  },
  methods: {
    openContextMenu(event, item) {
      event.preventDefault();

      this.contextMenu = {
        visible: true,
        x: event.clientX,
        y: event.clientY,
        item: item
      };
    },
    closeContextMenu() {
      this.contextMenu.visible = false;
    },
    duranteResize(e) {
      if (!this.resizing) return
      const diff = e.clientX - this.resizeStartX
      const novaLargura = this.resizeStartWidth + diff
      this.colDuamWidth = Math.max(60, Math.min(novaLargura, 300))
    },
    finalizarResize() {
      this.resizing = false
      document.removeEventListener('mousemove', this.duranteResize)
      document.removeEventListener('mouseup', this.finalizarResize)
      document.body.style.cursor = ''
      document.body.style.userSelect = ''
    },
    mudarPagina(pagina) {
      this.$emit('mudarPagina', pagina)
    },
    pagamento(g) {
      this.$emit('pagamento', g)
    },
    showModalbaixaManual(g) {
      this.$emit('baixa-manual', g)
    },
    showModalAlterarDuam(g) {
      this.$emit('alterar-duam', g)
    },
    printComprovante(g) {
      this.$emit('print-comprovante', g)
    },
    guiaDetalhe(g) {
      this.$emit('guia-detalhe', g)
    }
  }
}
</script>

<style scoped>
.duam-list-wrapper {
  --duam-font-size: 12px;

  --fs-xs:   calc(var(--duam-font-size) * 0.78);
  --fs-sm:   calc(var(--duam-font-size) * 0.857);
  --fs-base: var(--duam-font-size);
  --fs-md:   calc(var(--duam-font-size) * 1.07);
  --fs-lg:   calc(var(--duam-font-size) * 1.28);
  --fs-xl:   calc(var(--duam-font-size) * 1.57);
  --fs-icon: calc(var(--duam-font-size) * 1.7);

  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  font-size: var(--fs-base);
}

/* ═══════════ RESUMO ═══════════ */
.duam-resumo {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 8px;
  margin-bottom: 10px;
}

.resumo-card {
  background: #fff;
  border: 1px solid #e8eaed;
  border-radius: 8px;
  padding: 10px 12px;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.resumo-label {
  font-size: var(--fs-xs);
  font-weight: 500;
  color: #6b7280;
  text-transform: uppercase;
  letter-spacing: 0.03em;
}

.resumo-valor {
  font-size: var(--fs-xl);
  font-weight: 700;
  color: #1f2937;
}

.resumo-destaque {
  color: #4f46e5;
}

.resumo-success {
  color: #059669;
}

.resumo-warning {
  color: #ea580c;
}

/* ═══════════ TABELA ═══════════ */
.duam-table {
  background: #fff;
  border-radius: 8px;
  border: 1px solid #e8eaed;
}

/* ── Header ── */
.duam-header {
  display: flex;
  align-items: center;
  padding: 8px 12px;
  background: #fafbfc;
  border-bottom: 1px solid #e8eaed;
  border-radius: 8px 8px 0 0;
  font-size: var(--fs-xs);
  font-weight: 600;
  color: #6b7280;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

/* ── Row ── */
.duam-row {
  display: flex;
  align-items: center;
  padding: 8px 12px;
  border-bottom: 1px solid #f1f3f5;
  transition: background 0.15s ease;
}

.duam-row:last-child {
  border-bottom: none;
  border-radius: 0 0 8px 8px;
}

.duam-row:hover {
  background: #f8f9fb;
}

/* ── Colunas ── */
.col-duam {
  flex: 0 0 70px;
  min-width: 50px;
  position: relative;
}

.duam-header .col-duam {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

/* ── Resize Handle ── */
.resize-handle {
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  width: 6px;
  cursor: col-resize;
  background: transparent;
  transition: background 0.15s ease;
  z-index: 2;
}

.resize-handle:hover,
.resize-handle:active {
  background: #4f46e5;
  border-radius: 3px;
}

.col-contribuinte {
  flex: 0 0 350px;
  max-width: 350px;
  display: flex;
  align-items: center;
  overflow: hidden;
}

.col-valor {
  flex: 1.5 1 120px;
  min-width: 100px;
}

.col-tributo {
  flex: 0 1 60px;
  min-width: 45px;
}

.col-competencia {
  flex: 0 1 100px;
  min-width: 80px;
}

.col-vencimento {
  flex: 1 1 100px;
  min-width: 80px;
}

/* ── Vencimento Info ── */
.vencimento-info {
  display: flex;
  flex-direction: column;
}

.vencimento-atual {
  font-weight: 600;
  font-size: var(--fs-base);
  color: #1f2937;
  line-height: 1.3;
}

.vencimento-original {
  font-size: var(--fs-xs);
  color: #9ca3af;
  margin-top: 1px;
  line-height: 1.3;
}

.vencimento-original strong {
  font-weight: 600;
  color: #6b7280;
}

.col-situacao {
  flex: 0 1 auto;
  min-width: 60px;
  max-width: 160px;
  padding-right: 8px;
  overflow: hidden;
}

.col-acoes {
  flex: 0 0 36px;
  min-width: 36px;
  display: flex;
  justify-content: flex-end;
  flex-shrink: 0;
}

.col-acoes .dropdown-menu {
  z-index: 9999 !important;
}

/* ── Código DUAM ── */
.duam-codigo {
  font-weight: 600;
  font-size: var(--fs-base);
  color: #1f2937;
}

/* ── Contribuinte Info ── */
.contribuinte-info {
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.contribuinte-nome {
  font-weight: 600;
  font-size: var(--fs-base);
  color: #1f2937;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.contribuinte-doc {
  font-size: var(--fs-sm);
  color: #9ca3af;
  margin-top: 1px;
}

/* ── Valor ── */
.valor-info {
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.valor-total {
  font-weight: 700;
  font-size: var(--fs-md);
  color: #1f2937;
  line-height: 1.2;
}

.valor-detalhes {
  display: flex;
  flex-direction: column;
  gap: 0;
  margin-top: 2px;
}

.valor-detalhe-item {
  font-size: var(--fs-xs);
  color: #9ca3af;
  line-height: 1.3;
}

.valor-detalhe-item strong {
  font-weight: 600;
  color: #6b7280;
}

.valor-pago {
  font-size: var(--fs-xs);
  color: #10b981;
  font-weight: 600;
  margin-top: 2px;
}

/* ── Tributo ── */
.tributo-badge {
  display: inline-block;
  padding: 2px 6px;
  border-radius: 4px;
  font-size: var(--fs-sm);
  font-weight: 600;
  background: #f0f0ff;
  color: #4f46e5;
}

/* ── Status badges ── */
.status-badge {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 20px;
  font-size: var(--fs-sm);
  font-weight: 600;
  white-space: nowrap;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
}

.status-aberta {
  background: #fff7ed;
  color: #ea580c;
}

.status-vencida {
  background: #fef2f2;
  color: #dc2626;
}

.status-paga {
  background: #ecfdf5;
  color: #059669;
}

.status-outra {
  background: #f3f4f6;
  color: #6b7280;
}

/* ── Botão Ações (dropdown) ── */
.btn-acoes {
  width: 30px;
  height: 30px;
  padding: 0 !important;
  display: flex !important;
  align-items: center;
  justify-content: center;
  border-radius: 6px !important;
  border: 1px solid #e5e7eb !important;
  background: #fff !important;
  color: #6b7280 !important;
  font-size: var(--fs-lg);
  transition: all 0.15s ease;
}

.btn-acoes:hover {
  background: #f3f4f6 !important;
  color: #1f2937 !important;
}

/* ── Estado vazio ── */
.duam-empty {
  padding: 30px 12px;
  text-align: center;
  color: #9ca3af;
}

.duam-empty i {
  font-size: var(--fs-icon);
  margin-bottom: 8px;
  display: block;
}

.duam-empty p {
  font-size: var(--fs-base);
  margin: 0;
}

/* ═══════════ PAGINAÇÃO ═══════════ */
.duam-pagination-wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 8px;
  padding: 0 4px;
}

.pagination-info {
  font-size: var(--fs-sm);
  color: #6b7280;
}

.duam-pagination-wrapper >>> .duam-pagination {
  display: flex;
  list-style: none;
  padding: 0;
  margin: 0;
  gap: 4px;
}

.duam-pagination-wrapper >>> .page-item .page-link {
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 30px;
  height: 30px;
  padding: 0 8px;
  border-radius: 6px;
  border: 1px solid #e5e7eb;
  background: #fff;
  color: #4b5563;
  font-size: var(--fs-sm);
  font-weight: 500;
  cursor: pointer;
  transition: all 0.15s ease;
  text-decoration: none;
}

.duam-pagination-wrapper >>> .page-item .page-link:hover {
  background: #f3f4f6;
  border-color: #d1d5db;
  color: #1f2937;
}

.duam-pagination-wrapper >>> .page-item.active .page-link {
  background: #4f46e5;
  border-color: #4f46e5;
  color: #fff;
}

.duam-pagination-wrapper >>> .page-item.disabled .page-link {
  opacity: 0.4;
  cursor: not-allowed;
  pointer-events: none;
}

/* ═══════════ RESPONSIVO — TABLET (≤ 992px) ═══════════ */
@media (max-width: 992px) {
  .duam-resumo {
    grid-template-columns: repeat(2, 1fr);
    gap: 6px;
  }

  .duam-header {
    display: none;
  }

  .duam-row {
    flex-wrap: wrap;
    gap: 6px;
    padding: 10px;
    position: relative;
  }

  .duam-row [data-label]::before {
    content: attr(data-label);
    display: block;
    font-size: var(--fs-xs);
    font-weight: 600;
    color: #9ca3af;
    text-transform: uppercase;
    letter-spacing: 0.03em;
    margin-bottom: 2px;
  }

  .col-duam {
    flex: 0 0 auto;
    min-width: auto;
  }

  .col-contribuinte {
    flex: 1 1 calc(100% - 120px);
    min-width: 0;
  }

  .col-valor {
    flex: 0 0 calc(50% - 6px);
    min-width: auto;
  }

  .col-tributo {
    flex: 0 0 calc(50% - 6px);
    min-width: auto;
  }

  .col-competencia {
    flex: 0 0 calc(50% - 6px);
    min-width: auto;
  }

  .col-vencimento {
    flex: 0 0 calc(50% - 6px);
    min-width: auto;
  }

  .col-situacao {
    flex: 0 0 auto;
    min-width: auto;
    max-width: none;
    overflow: visible;
  }
}

/* ═══════════ RESPONSIVO — MOBILE (≤ 576px) ═══════════ */
@media (max-width: 576px) {
  .duam-resumo {
    grid-template-columns: 1fr 1fr;
    gap: 6px;
  }

  .resumo-card {
    padding: 8px 10px;
  }

  .resumo-valor {
    font-size: var(--fs-lg);
  }

  .duam-row {
    padding: 8px;
    gap: 6px;
  }

  .col-duam {
    flex: 0 0 auto;
  }

  .col-contribuinte {
    flex: 1 1 100%;
    order: -1;
  }

  .col-valor,
  .col-tributo,
  .col-competencia,
  .col-vencimento {
    flex: 0 0 calc(50% - 3px);
  }

  .col-situacao {
    flex: 0 0 auto;
  }

  .duam-pagination-wrapper {
    flex-direction: column;
    gap: 8px;
    align-items: center;
  }

  .duam-pagination-wrapper >>> .page-item .page-link {
    min-width: 28px;
    height: 28px;
    font-size: var(--fs-xs);
  }
}
</style>